<template>
    <div class="cooking-equipment-page">
        <!-- 搜索筛选区域 -->
        <el-card class="search-filter-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="设备名称">
                    <el-input v-model="searchForm.equipmentName" placeholder="请输入设备名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="设备类型">
                    <el-select v-model="searchForm.equipmentType" placeholder="请选择设备类型" clearable>
                        <el-option label="炒制设备" value="frying"></el-option>
                        <el-option label="蒸煮设备" value="steaming"></el-option>
                        <el-option label="烘烤设备" value="baking"></el-option>
                        <el-option label="油炸设备" value="fryingOil"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">搜索</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                    <el-button type="success" style="margin-top: 10px;" @click="showAddDialog">新增设备</el-button>
                </el-form-item>
            </el-form>

        </el-card>

        <!-- 设备列表展示区域 -->
        <el-card class="equipment-list-card">
            <el-table :data="equipmentList" border style="width: 100%">
                <el-table-column prop="id" label="序号" width="80" align="center"></el-table-column>
                <el-table-column prop="name" label="设备名称" width="180" align="center"></el-table-column>
                <el-table-column prop="type" label="设备类型" width="150" align="center">
                    <template #default="{ row }">
                        <el-tag :type="getTagType(row.type)">{{ row.typeLabel }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="capacity" label="产能（份/小时）" width="150" align="center"></el-table-column>
                <el-table-column prop="power" label="功率（KW）" width="120" align="center"></el-table-column>
                <el-table-column prop="temperatureRange" label="温度范围（℃）" width="180" align="center"></el-table-column>
                <el-table-column prop="description" label="设备描述"></el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template #default="{ row }">
                        <el-button type="text" @click="showDetailDialog(row)">详情</el-button>
                        <el-button type="text" @click="showEditDialog(row)">编辑</el-button>
                        <el-button type="text" @click="handleDelete(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>

        <!-- 设备详情对话框 -->
        <el-dialog title="设备详情" :visible.sync="detailDialogVisible" width="50%" @close="closeDetailDialog"
            :z-index="3000" append-to-body>
            <el-form :model="currentDetail" label-width="120px">
                <el-form-item label="设备名称">{{ currentDetail.name }}</el-form-item>
                <el-form-item label="设备类型">{{ currentDetail.typeLabel }}</el-form-item>
                <el-form-item label="产能（份/小时）">{{ currentDetail.capacity }}</el-form-item>
                <el-form-item label="功率（KW）">{{ currentDetail.power }}</el-form-item>
                <el-form-item label="温度范围（℃）">{{ currentDetail.temperatureRange }}</el-form-item>
                <el-form-item label="设备描述">{{ currentDetail.description }}</el-form-item>
                <el-form-item label="适用场景">
                    <el-tag v-for="(scene, index) in currentDetail.scenarios" :key="index" type="info">{{ scene
                        }}</el-tag>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="closeDetailDialog">关闭</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 新增/编辑设备对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="addEditDialogVisible" width="50%" @close="closeAddEditDialog"
            :z-index="3000" append-to-body>
            <el-form :model="form" ref="formRef" label-width="120px" :rules="formRules">
                <el-form-item label="设备名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入设备名称"></el-input>
                </el-form-item>
                <el-form-item label="设备类型" prop="type">
                    <el-select v-model="form.type" placeholder="请选择设备类型">
                        <el-option label="炒制设备" value="frying"></el-option>
                        <el-option label="蒸煮设备" value="steaming"></el-option>
                        <el-option label="烘烤设备" value="baking"></el-option>
                        <el-option label="油炸设备" value="fryingOil"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产能（份/小时）" prop="capacity">
                    <el-input v-model.number="form.capacity" placeholder="请输入产能"></el-input>
                </el-form-item>
                <el-form-item label="功率（KW）" prop="power">
                    <el-input v-model.number="form.power" placeholder="请输入功率"></el-input>
                </el-form-item>
                <el-form-item label="温度范围（℃）" prop="temperatureRange">
                    <el-input v-model="form.temperatureRange" placeholder="请输入温度范围"></el-input>
                </el-form-item>
                <el-form-item label="设备描述" prop="description">
                    <el-input type="textarea" v-model="form.description" placeholder="请输入设备描述"></el-input>
                </el-form-item>
                <el-form-item label="适用场景" prop="scenariosStr">
                    <el-input v-model="form.scenariosStr" placeholder="请输入适用场景，多个用逗号分隔"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="closeAddEditDialog">取消</el-button>
                    <el-button type="primary" @click="handleAddEditConfirm">确定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formRules: {
                name: [
                    { required: true, message: '请输入设备名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '设备名称长度需在 2-50 字符之间', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择设备类型', trigger: 'change' }
                ],
                capacity: [
                    { required: true, message: '请输入产能', trigger: 'blur' },
                    { type: 'number', message: '产能必须为数字', trigger: 'blur' },
                    { min: 1, message: '产能不能小于 1（份/小时）', trigger: 'blur' }
                ],
                power: [
                    { required: true, message: '请输入功率', trigger: 'blur' },
                    { type: 'number', message: '功率必须为数字', trigger: 'blur' },
                    { min: 0.1, message: '功率不能小于 0.1（KW）', trigger: 'blur' }
                ],
                temperatureRange: [
                    { required: true, message: '请输入温度范围', trigger: 'blur' },
                    { pattern: /^[\d\-~]+$/, message: '温度范围格式无效（如：50-300、常温-300）', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: '请输入设备描述', trigger: 'blur' },
                    { min: 10, message: '设备描述需至少 10 字符', trigger: 'blur' }
                ],
                scenariosStr: [
                    { required: true, message: '请输入适用场景', trigger: 'blur' },
                    { min: 2, message: '适用场景需至少 2 字符（多个用逗号分隔）', trigger: 'blur' }
                ]
            },
            searchForm: {
                equipmentName: '',
                equipmentType: ''
            },
            equipmentList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            detailDialogVisible: false,      // 控制详情对话框显示
            currentDetail: {},
            addEditDialogVisible: false,     // 控制新增/编辑对话框显示
            dialogTitle: '新增设备',
            form: {
                id: '',
                name: '',
                type: '',
                typeLabel: '',
                capacity: '',
                power: '',
                temperatureRange: '',
                description: '',
                scenarios: [],
                scenariosStr: ''
            },
            editingItem: null
        };
    },
    created() {
        this.fetchEquipmentList();
    },
    methods: {
        fetchEquipmentList() {
            this.equipmentList = [
                { id: 1, name: '全自动行星搅拌炒锅', type: 'frying', typeLabel: '炒制设备', capacity: 500, power: 15, temperatureRange: '50-300', description: '倾斜式锅体，行星式搅拌...', scenarios: ['酱料炒制', '预制菜炒制', '馅料制作'] },
                { id: 2, name: '电磁大锅灶', type: 'frying', typeLabel: '炒制设备', capacity: 800, power: 20, temperatureRange: '常温-300', description: '采用电磁加热...', scenarios: ['大锅菜烹饪', '汤品熬制'] },
                { id: 3, name: '多层蒸汽蒸锅', type: 'steaming', typeLabel: '蒸煮设备', capacity: 1000, power: 12, temperatureRange: '100', description: '不锈钢多层架结构...', scenarios: ['主食蒸煮', '根茎类食材蒸煮'] },
                { id: 4, name: '高压蒸煮锅', type: 'steaming', typeLabel: '蒸煮设备', capacity: 600, power: 18, temperatureRange: '高温高压', description: '密封式锅体...', scenarios: ['难熟食材加工'] },
                { id: 5, name: '热风循环烤箱', type: 'baking', typeLabel: '烘烤设备', capacity: 300, power: 10, temperatureRange: '50-250', description: '通过热风均匀加热...', scenarios: ['烘焙', '肉类烤制'] },
                { id: 6, name: '全自动油炸线', type: 'fryingOil', typeLabel: '油炸设备', capacity: 800, power: 25, temperatureRange: '160-200', description: '包含上料、油炸...', scenarios: ['炸鸡块', '油条', '薯条'] }
            ];
            this.total = this.equipmentList.length;
        },
        handleSearch() {
            let filteredList = this.equipmentList.filter(item => {
                let nameMatch = true;
                let typeMatch = true;
                if (this.searchForm.equipmentName) {
                    nameMatch = item.name.includes(this.searchForm.equipmentName);
                }
                if (this.searchForm.equipmentType) {
                    typeMatch = item.type === this.searchForm.equipmentType;
                }
                return nameMatch && typeMatch;
            });
            this.equipmentList = filteredList;
            this.total = filteredList.length;
        },
        resetSearch() {
            this.searchForm = { equipmentName: '', equipmentType: '' };
            this.fetchEquipmentList();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        getTagType(type) {
            const types = {
                frying: 'primary',
                steaming: 'success',
                baking: 'warning',
                fryingOil: 'danger'
            };
            return types[type] || '';
        },
        showDetailDialog(row) {          // 显示详情对话框
            this.currentDetail = { ...row };
            this.detailDialogVisible = true;
        },
        closeDetailDialog() {             // 关闭详情对话框
            this.detailDialogVisible = false;
        },
        showAddDialog() {                  // 显示新增对话框
            this.dialogTitle = '新增设备';
            this.form = {
                id: '',
                name: '',
                type: '',
                typeLabel: '',
                capacity: '',
                power: '',
                temperatureRange: '',
                description: '',
                scenarios: [],
                scenariosStr: ''
            };
            this.editingItem = null;
            this.addEditDialogVisible = true;
        },
        showEditDialog(row) {              // 显示编辑对话框
            this.dialogTitle = '编辑设备';
            this.editingItem = row;
            this.form = {
                id: row.id,
                name: row.name,
                type: row.type,
                typeLabel: row.typeLabel,
                capacity: row.capacity,
                power: row.power,
                temperatureRange: row.temperatureRange,
                description: row.description,
                scenarios: [...row.scenarios],
                scenariosStr: row.scenarios.join(',')
            };
            this.addEditDialogVisible = true;
        },
        closeAddEditDialog() {             // 关闭新增/编辑对话框
            this.addEditDialogVisible = false;
        },
        handleDelete(row) {
            this.$confirm('确定要删除该设备吗？', '提示', { type: 'warning' }).then(() => {
                const index = this.equipmentList.findIndex(item => item.id === row.id);
                if (index !== -1) {
                    this.equipmentList.splice(index, 1);
                    this.total = this.equipmentList.length;
                    this.$message({ type: 'success', message: '删除成功' });
                }
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        },
        handleAddEditConfirm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    const newForm = { ...this.form };
                    newForm.scenarios = newForm.scenariosStr.split(',').map(item => item.trim());

                    // 根据类型设置标签
                    const typeMap = {
                        frying: '炒制设备',
                        steaming: '蒸煮设备',
                        baking: '烘烤设备',
                        fryingOil: '油炸设备'
                    };
                    newForm.typeLabel = typeMap[newForm.type] || '';

                    if (this.editingItem) {
                        const index = this.equipmentList.findIndex(item => item.id === this.editingItem.id);
                        if (index !== -1) {
                            this.equipmentList.splice(index, 1, newForm);
                        }
                    } else {
                        newForm.id = Date.now(); // 更安全的ID生成方式
                        this.equipmentList.push(newForm);
                        this.total = this.equipmentList.length;
                    }
                    this.closeAddEditDialog();
                    this.$message({ type: 'success', message: this.editingItem ? '编辑成功' : '新增成功' });
                } else {
                    console.log('表单验证失败');
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.cooking-equipment-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-filter-card {
    margin-bottom: 20px;
}

.search-form {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.equipment-list-card {
    margin-bottom: 20px;
}

/* 表单项间距 */
.el-form-item {
    margin-bottom: 18px;
}

/* 标签样式 */
.el-tag {
    margin-right: 8px;
    margin-bottom: 8px;
}

/* 分页器外边距 */
.el-pagination {
    margin-top: 20px;
    text-align: right;
}

/* 修复对话框层级问题 */
::v-deep .el-dialog__wrapper {
    z-index: 9999 !important;
}
</style>
